function waitElementLoaded(selector, callback, interval = 100, retryTimeout = 5000) {
  const checker = setInterval(function () {
    const element = document.querySelector(selector);
    if (element) {
      callback();
      clearInterval(checker);
    }
  }, interval);

  setTimeout(function () {
    clearInterval(checker);
  }, retryTimeout);
}

function runLogic() {
  waitElementLoaded('.scaaf-message-bar', function () {
    waitElementLoaded('#fsb_container', function () {
      let messageBar = document.querySelector('.scaaf-message-bar');
      let fsbContainer = document.getElementById('fsb_container');
      if (fsbContainer && messageBar) {
        let fsbHeight = fsbContainer.offsetHeight;

        if (fsbHeight === 0) {
          fsbHeight = 48;
        }

        messageBar.style.marginTop = fsbHeight + 'px';
        fsbContainer.style.minHeight = fsbHeight + 'px';

        fsbContainer.style.height = 'unset';
        fsbContainer.style.minHeight = 'unset';
      }
    });
  });
}

function executeWithRetry(maxRetries = 5, delay = 1000) {
  let attempt = 0;

  const interval = setInterval(() => {
    attempt++;
    console.log(`Attempt ${attempt}: Running logic...`);
    runLogic();

    if (attempt >= maxRetries) {
      clearInterval(interval);
    }
  }, delay);
}

setTimeout(() => {
  executeWithRetry();
}, 4000);
